import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AdminAuthContext } from "../../admin/context/AdminAuthContext";

const AdminProtectedRoute = ({ children }) => {
  const { adminAuth } = useContext(AdminAuthContext);

  // While checking session, show nothing (loading)
  if (adminAuth.isChecking) {
    return null;
  }

  // If not authenticated, redirect to admin login
  if (!adminAuth.isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  // Authenticated - render children
  return children;
};

export default AdminProtectedRoute;

